/** Lower case without Vietnamese diacritics, so "so cai" finds "Sổ cái". */
export function fold(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();
}

/** Every word of `query` appears in `haystack` (diacritics and case ignored). */
export function matches(haystack: string, query: string): boolean {
  const h = fold(haystack);
  return fold(query)
    .split(/\s+/)
    .filter(Boolean)
    .every((w) => h.includes(w));
}
